import styles from "./index.module.scss";
import cn from "classnames";

const TableRow = ({ category, data, valueSymbol = "$" }) => {
  return (
    <div className={styles.table_row}>
      <div className={cn(styles.table_row_cell, styles.table_row_category)}>
        {category}
      </div>
      {data?.map((elem, idx) => (
        <div
          className={styles.table_row_cell}
          key={`${category}_${idx}}_${elem}`}
        >
          {valueSymbol === "%"
            ? `${elem}${valueSymbol}`
            : `${valueSymbol}${elem}`}
        </div>
      ))}
    </div>
  );
};

export default TableRow;
